module.exports = __webpack_public_path__ + "static/media/71hMnIk21hL._SL1500_.141698d4.jpg";